/**
 * Aiká — Grid de fotos rotativo (sem clique, só decorativo)
 * Cada célula troca sozinha entre as imagens que tiver (crossfade),
 * com um pequeno atraso diferente por célula — pra não trocarem todas
 * no mesmo instante, dando um efeito mais orgânico de "mural vivo".
 */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-photo-cell]').forEach((cell) => {
    const images = Array.from(cell.querySelectorAll('.aika-photo-grid__image'));
    if (images.length <= 1) return;

    const speed = (parseFloat(cell.dataset.speed) || 4) * 1000;
    const stagger = (parseFloat(cell.dataset.stagger) || 0) * 1000;

    let current = 0;

    const rotate = () => {
      images[current].classList.remove('is-active');
      current = (current + 1) % images.length;
      images[current].classList.add('is-active');
    };

    setTimeout(() => {
      setInterval(rotate, speed);
    }, stagger);
  });
});
